const initialState = {
  encryptionKey: null,
  loggedInUserDetails: null,
  otherUserDetails: null,
  firstLogin: null,
  clientSubscriptions: [],
  themeSettingsData: null,
  userRoleFilters: null
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case "SET_KEY":
      return { ...state, encryptionKey: action.payload };

    case "LOGIN_SUCCESS":
      return {
        ...state,
        loggedInUserDetails: action.payload.loggedInUserDetails,
        otherUserDetails: action.payload.otherUserDetails,
        firstLogin: action.payload.firstLogin,
        clientSubscriptions: action.payload.clientSubscriptions,
        themeSettingsData: action.payload.themeSettingsData,
        encryptionKey: action.payload.encryptionKey,
      };
    case "AUDITEE_LOGIN_SUCCESS":
      return {
        ...state,
        loggedInUserDetails: action.payload.loggedInUserDetails,
        encryptionKey: action.payload.encryptionKey,
      };
    case "SET_LOGGED_IN_USER_DETAILS":
      return {
        ...state,
        loggedInUserDetails: action.payload
      };
    case "UPDATE_THEME_SETTINGS":
      return {
        ...state,
        themeSettingsData: action.payload,
      };
    case "SET_OTHER_USER_DETAILS":
      return {
        ...state,
        otherUserDetails: action.payload
      };
    case "SET_USER_ROLE_FILTERS":
      return { 
        ...state, 
        userRoleFilters: action.payload 
      };
    case "SET_CLIENT_SUBSCRIPTION":
      return {
        ...state,
        clientSubscriptions: action.payload
      };
    case "LOGOUT":
      return initialState;

    default:
      return state;
  }
}

// Action creators
export const setKey = (key) => ({ type: "SET_KEY", payload: key });
export const loginSuccess = (payload) => ({ type: "LOGIN_SUCCESS", payload });
export const auditeeLoginSuccess = (payload) => ({ type: "AUDITEE_LOGIN_SUCCESS", payload });
export const updateThemeSettings = (themeSettings) => ({
  type: "UPDATE_THEME_SETTINGS",
  payload: themeSettings,
});
export const setLoggedInUserDetails = (payload) => ({
  type: "SET_LOGGED_IN_USER_DETAILS",
  payload
});
export const setOtherUserDetails = (payload) => ({
  type: "SET_OTHER_USER_DETAILS",
  payload
});
export const setUserRoleFilters = (payload) => ({
  type: "SET_USER_ROLE_FILTERS",
  payload
});
export const setClientSubscription = (payload) => ({
  type: "SET_CLIENT_SUBSCRIPTION",
  payload
})
export const logout = () => ({ type: "LOGOUT" });